import React from "react";
import classes from "./MyLoadingIcon.module.css"

const MyLoadingIcon = function() {
    return(
        <div className={classes.myLoadingIconWrapper}>
            <div className={classes.myLoadingIcon}>

            </div>
        </div>
    )
};

export default MyLoadingIcon;